import { roleAccent } from "./organigramaColors";
import { borjaRole } from "./organigramaBorjaRole";
import { ireneRole } from "./organigramaIreneRole";
import { miguelRole } from "./organigramaMiguelRole";
import { alex, chiara, disenadoras, nina } from "./organigramaLevel2Roles";

export const DEFAULT_ROLES = {
  irene: ireneRole,
  miguel: miguelRole,
  borja: borjaRole,
  imma: {
    id: "imma",
    section: "2.6",
    name: "Imma",
    role: "Senior Merchandising & Production Manager",
    subtitle: null,
    reportaA: "Chief Operations & Financial Officer (COFO)",
    colaboraCon:
      "Founder (Irene), EC (Miguel), Head of Design, Business Development, Guillermo y equipos de merchandising de China.",
    accent: roleAccent("imma"),
    foco: [],
    noFoco: [],
    misionLabel: "Misión",
    mision:
      "Garantizar la correcta ejecución de todos los desarrollos y producciones de Stage Design Studio y dar soporte técnico y operativo a No Man's Label cuando sea necesario, asegurando que cada proyecto cumple los estándares de calidad, coste, plazos y servicio al cliente.\n\nEs la responsable de transformar las decisiones comerciales en una ejecución impecable, actuando como referente técnico y operativo para el equipo y como apoyo en la resolución de incidencias complejas.",
    responsabilidadesLabel: "Áreas de responsabilidad",
    responsabilidades: [
      {
        title: "Merchandising Senior",
        items: [
          "Liderar el seguimiento operativo de todos los pedidos de Stage Design Studio desde la confirmación del cliente hasta la entrega final.",
          "Coordinar el trabajo diario con los merchandisers de China.",
          "Garantizar que cada desarrollo y producción cumple los estándares acordados de calidad, coste y plazo.",
        ],
      },
      {
        title: "Coordinación con Business Development",
        items: [
          "Trabajar estrechamente con los Business Developers para asegurar que la estrategia comercial se traduce en una ejecución excelente.",
        ],
        groups: [
          {
            label: "Dar soporte técnico en:",
            items: [
              "desarrollo de producto",
              "precios",
              "proveedores",
              "riesgos de producción",
              "planificación",
            ],
          },
        ],
      },
      {
        title: "Gestión de proveedores",
        items: [
          "Coordinar y supervisar a los proveedores durante todo el proceso.",
        ],
        groups: [
          {
            label: "Especial atención a:",
            items: [
              "calidad",
              "workmanship",
              "cumplimiento de timings",
              "costes",
              "comunicación",
            ],
          },
        ],
      },
      {
        title: "Calidad y resolución de incidencias",
        items: [
          "Actuar como referente técnico cuando aparecen incidencias en SMS, producción, calidad, fitting y confección.",
          "Definir conjuntamente con China la mejor solución antes de que el problema llegue al cliente.",
        ],
      },
      {
        title: "Mentoría del equipo de merchandising",
        items: [
          "Desarrollar y acompañar a los merchandisers de China.",
          "Su objetivo no es resolver siempre los problemas personalmente, sino conseguir que el equipo sea cada vez más autónomo.",
        ],
        groups: [
          {
            label: "Esto incluye:",
            items: [
              "formación",
              "seguimiento",
              "feedback",
              "transferencia de conocimiento",
            ],
          },
        ],
      },
      {
        title: "Coordinación con Diseño",
        items: [
          "Trabajar junto al equipo de diseño para asegurar que los desarrollos son técnicamente viables.",
        ],
        groups: [
          {
            label: "Revisar:",
            items: [
              "medidas",
              "construcción",
              "acabados",
              "accesorios",
              "packing",
              "etiquetado",
            ],
          },
        ],
      },
      {
        title: "Soporte a NML",
        items: [
          "Dar soporte puntual a No Man's Label cuando existan incidencias relevantes en SMS, producción y calidad.",
          "Especialmente en clientes estratégicos o desarrollos complejos.",
        ],
      },
      {
        title: "Mejora continua",
        items: [
          "Detectar riesgos antes de que aparezcan.",
          "Mejorar procesos de merchandising.",
          "Estandarizar procedimientos.",
          "Compartir buenas prácticas entre España y China.",
          "Incorporar herramientas de IA que reduzcan tareas repetitivas y mejoren la calidad del seguimiento.",
        ],
      },
    ],
    kpiGroups: [
      {
        title: "Ejecución",
        items: [
          "On Time Delivery (SMS y producción)",
          "Cumplimiento de timings",
          "Nivel de incidencias",
        ],
      },
      {
        title: "Calidad",
        items: [
          "Reducción de reclamaciones",
          "Calidad de workmanship",
          "Aprobación de SMS en primera revisión",
        ],
      },
      {
        title: "Merchandising",
        items: [
          "Cumplimiento de costes objetivo",
          "Precisión en información técnica",
          "Nivel de autonomía del equipo de China",
        ],
      },
      {
        title: "Cliente",
        items: [
          "Nivel de satisfacción de Business Development",
          "Calidad del servicio al cliente",
          "Rapidez en resolución de incidencias",
        ],
      },
      {
        title: "Organización",
        items: [
          "Reducción de incidencias repetitivas",
          "Implantación de mejoras de proceso",
          "Transferencia de conocimiento al equipo",
        ],
      },
    ],
    kpis: [],
  },
  businessDeveloper: {
    id: "businessDeveloper",
    section: "2.1",
    name: "LYDIA - MIKA",
    role: "Business Developer / Key Account Manager",
    subtitle: null,
    reportaAItems: [
      "Founder & Chief Product, Commercial & Partnerships Officer (Irene) – estrategia comercial, clientes y desarrollo de negocio.",
      "Executive Chair (Miguel) – objetivos de crecimiento, organización y sistemas.",
    ],
    colaboraConItems: [
      "COFO (Borja) para asegurar la viabilidad operativa y financiera de los proyectos.",
      "Head of Design.",
      "Equipo de Diseño.",
      "Senior Merchandising.",
      "Equipos de China.",
      "Business Operations Coordinator.",
    ],
    accent: roleAccent("businessDeveloper"),
    foco: [],
    noFoco: [],
    misionLabel: "Misión",
    mision:
      "Desarrollar, consolidar y hacer crecer las cuentas asignadas mediante una profunda comprensión del cliente, liderando toda su experiencia con Stage Design Studio y No Man's Label y asegurando que cada interacción genere confianza, valor y nuevas oportunidades de negocio.\n\nEs el responsable de representar a la empresa frente al cliente y de asegurar que toda la organización trabaja alineada con sus necesidades y expectativas.",
    responsabilidadesLabel: "Áreas de responsabilidad",
    responsabilidades: [
      {
        title: "Desarrollo de negocio",
        items: [
          "Identificar nuevas oportunidades de negocio dentro de las cuentas existentes.",
          "Abrir nuevos clientes y nuevos conceptos.",
          "Elaborar el plan anual de crecimiento de cada cuenta.",
          "Detectar oportunidades de nuevas categorías y nuevos proveedores.",
        ],
      },
      {
        title: "Gestión integral del cliente",
        items: [
          "Ser el responsable de la experiencia global del cliente durante todo el proceso comercial.",
          "Cada cliente debe sentir que conoce perfectamente su negocio y que siempre está un paso por delante de sus necesidades.",
        ],
        groups: [
          {
            label: "Esto incluye:",
            items: [
              "Preparación de reuniones.",
              "Presentaciones.",
              "Seguimiento.",
              "Comunicación.",
              "Gestión de expectativas.",
              "Resolución de incidencias comerciales.",
            ],
          },
        ],
      },
      {
        title: "Estrategia de producto",
        items: [
          "Trabajar junto con Irene y el equipo de diseño para garantizar que las colecciones responden a identidad del cliente, posicionamiento, precios objetivo y necesidades comerciales.",
          "El Business Developer es responsable de asegurar que las colecciones presentadas están al nivel esperado por cada cliente.",
        ],
      },
      {
        title: "Showrooms",
        items: [
          "Responsable de que el showroom correspondiente a sus clientes esté permanentemente preparado.",
          "El showroom debe transmitir el nivel de la empresa incluso antes de empezar una reunión.",
        ],
        groups: [
          {
            label: "Esto incluye, en colaboración con el equipo de Diseño:",
            items: [
              "actualización de colecciones",
              "selección de prendas",
              "orden y presentación",
              "materiales de apoyo",
              "storytelling de producto",
            ],
          },
        ],
      },
      {
        title: "Preparación de visitas",
        items: [
          "Cada reunión debe estar preparada con el mismo nivel de exigencia que una presentación comercial.",
        ],
        groups: [
          {
            label: "Planificar y coordinar:",
            items: [
              "agendas",
              "colecciones",
              "muestras",
              "información comercial",
              "documentación",
              "objetivos de cada visita",
            ],
          },
        ],
      },
      {
        title: "Inteligencia de mercado",
        items: [
          "Analizar tendencias.",
          "Estudiar la competencia.",
          "Compartir información relevante con Diseño y Dirección.",
          "Mantener actualizado el conocimiento del cliente.",
        ],
      },
      {
        title: "Coordinación interna",
        items: [
          "Trabajar de forma coordinada con Diseño, Merchandising, Operaciones, China y Logística.",
        ],
        groups: [
          {
            label: "Asegurando que toda la organización entiende:",
            items: [
              "prioridades",
              "timings",
              "objetivos",
              "expectativas del cliente",
            ],
          },
        ],
      },
      {
        title: "Sistemas",
        items: [
          "Mantener Matrix actualizado con visitas, oportunidades, previsiones, contactos, evolución de ventas y próximos pasos.",
        ],
      },
    ],
    kpiGroups: [
      {
        title: "Comerciales",
        items: [
          "Facturación.",
          "Margen bruto.",
          "Crecimiento de clientes existentes.",
          "Apertura de nuevos clientes.",
          "Apertura de nuevos conceptos.",
        ],
      },
      {
        title: "Cliente",
        items: [
          "Retención de clientes.",
          "Nivel de satisfacción.",
          "Calidad de la experiencia del cliente.",
          "Calidad de las reuniones.",
          "Cumplimiento del plan anual de visitas.",
        ],
      },
      {
        title: "Producto",
        items: [
          "Hit Rate de muestras.",
          "Alineación entre colección presentada y necesidades del cliente.",
          "Nivel de innovación comercial.",
        ],
      },
      {
        title: "Organización",
        items: [
          "Showrooms preparados y actualizados.",
          "Calidad de los recaps.",
          "Actualización de Matrix.",
          "Coordinación entre departamentos.",
        ],
      },
    ],
    kpis: [],
  },
  agustina: {
    id: "agustina",
    section: "2.2",
    name: "Agustina Mich",
    role: "Head of Design & Product",
    subtitle: null,
    reportaAItems: [
      "Founder & Chief Product, Commercial & Partnerships Officer (Irene) – visión de producto, estrategia comercial y desarrollo de clientes.",
      "Colabora estrechamente con el EC (Miguel) en planificación de recursos y prioridades estratégicas.",
      "Colabora con el COFO (Borja) para asegurar la viabilidad, planificación y correcta ejecución de los desarrollos.",
    ],
    accent: roleAccent("agustina"),
    foco: [],
    noFoco: [],
    misionLabel: "Misión",
    mision:
      "Liderar la estrategia de diseño y desarrollo de producto de Stage Design Studio y No Man's Label, transformando la visión comercial de la empresa en colecciones innovadoras, comercialmente relevantes y técnicamente viables.\n\nGarantizar que el nivel creativo, la velocidad de respuesta y la calidad de las colecciones mantengan a la empresa como un partner estratégico para sus clientes.\n\nEs la responsable de convertir las ideas en producto y de hacer crecer continuamente el talento del equipo de diseño.",
    responsabilidadesLabel: "Áreas de responsabilidad",
    responsabilidades: [
      {
        title: "Dirección del equipo de Diseño",
        items: ["Liderar, desarrollar y organizar el equipo de diseño."],
        groups: [
          {
            label: "Responsable de:",
            items: [
              "planificación de recursos.",
              "asignación de proyectos.",
              "seguimiento de cargas de trabajo.",
              "desarrollo profesional del equipo.",
              "mantenimiento de un alto nivel creativo y técnico.",
            ],
          },
        ],
      },
      {
        title: "Dirección de Producto",
        items: [
          "Transformar las necesidades de los clientes en colecciones comerciales.",
        ],
        groups: [
          {
            label: "Definir junto con Irene:",
            items: [
              "arquitectura de colección.",
              "categorías.",
              "plataformas de producto.",
              "materiales prioritarios.",
              "equilibrio entre innovación y comercialidad.",
            ],
          },
        ],
      },
      {
        title: "Dirección Creativa",
        items: [
          "Supervisar la calidad creativa antes de cualquier presentación.",
        ],
        groups: [
          {
            label: "Garantizar que todas las colecciones reflejan:",
            items: [
              "identidad del cliente.",
              "ADN de SDS y NML.",
              "innovación.",
              "diferenciación.",
              "viabilidad industrial.",
            ],
          },
        ],
      },
      {
        title: "Desarrollo de Colecciones",
        items: [
          "Coordinar la preparación de todas las colecciones para clientes.",
          "Garantizando que cada colección llegue al cliente completamente preparada.",
        ],
        groups: [
          {
            label: "Responsable de:",
            items: [
              "moodboards.",
              "storytelling.",
              "selección de prendas.",
              "presentaciones.",
              "fichas técnicas.",
              "materiales de apoyo.",
            ],
          },
        ],
      },
      {
        title: "Sourcing Estratégico",
        items: [
          "Mantener actualizada la biblioteca de materiales y tendencias.",
        ],
        groups: [
          {
            label: "Buscar continuamente nuevas oportunidades en:",
            items: [
              "tejidos.",
              "accesorios.",
              "trims.",
              "lavados.",
              "técnicas.",
              "proveedores.",
            ],
          },
        ],
      },
      {
        title: "Relaciones con Proveedores",
        items: [
          "Visitar regularmente proveedores nacionales e internacionales.",
        ],
        groups: [
          {
            label: "Objetivos:",
            items: [
              "mejorar workmanship.",
              "desarrollar nuevas capacidades.",
              "formar equipos técnicos.",
              "transmitir estándares de Stage Design Studio.",
            ],
          },
        ],
      },
      {
        title: "Clientes",
        items: [
          "Acompañar a Irene en reuniones estratégicas con clientes.",
          "Dar soporte creativo y técnico.",
          "Traducir el feedback del cliente en acciones concretas para el equipo de diseño.",
        ],
      },
      {
        title: "Ferias y Shopping Trips",
        items: [
          "Definir los objetivos de cada viaje y asegurar la transferencia del conocimiento adquirido al resto del equipo.",
        ],
        groups: [
          {
            label: "Diseñar y coordinar la agenda anual de:",
            items: [
              "ferias.",
              "viajes de sourcing.",
              "shopping trips.",
              "visitas a proveedores.",
            ],
          },
        ],
      },
      {
        title: "Showrooms",
        items: ["Responsable del nivel creativo de los showrooms."],
        groups: [
          {
            label: "Garantizar que:",
            items: [
              "reflejan el posicionamiento de la empresa.",
              "están permanentemente actualizados.",
              "inspiran al cliente.",
              "ayudan a vender.",
            ],
          },
        ],
      },
      {
        title: "Innovación",
        items: ["Crear una cultura de innovación permanente."],
        groups: [
          {
            label: "Impulsar la incorporación de:",
            items: [
              "AI.",
              "herramientas 3D.",
              "nuevas metodologías de diseño.",
              "nuevas formas de presentar producto.",
            ],
          },
        ],
      },
      {
        title: "Desarrollo del equipo",
        items: [
          "Mentorizar al equipo de diseño.",
          "Identificar fortalezas.",
          "Detectar necesidades de formación.",
          "Construir un equipo cada vez más autónomo y preparado para crecer.",
        ],
      },
    ],
    kpiGroups: [
      {
        title: "Producto",
        items: [
          "Hit Rate de muestras.",
          "Número de modelos aprobados por cliente.",
          "Tiempo de desarrollo.",
          "Nivel de innovación de las colecciones.",
        ],
      },
      {
        title: "Diseño",
        items: [
          "Calidad de las presentaciones.",
          "Nivel creativo de los showrooms.",
          "Calidad técnica de las fichas.",
          "Organización de la biblioteca de materiales.",
        ],
      },
      {
        title: "Equipo",
        items: [
          "Desarrollo del equipo de diseño.",
          "Cumplimiento de timings.",
          "Equilibrio de cargas de trabajo.",
          "Nivel de autonomía del equipo.",
        ],
      },
      {
        title: "Clientes",
        items: [
          "Satisfacción de clientes.",
          "Calidad de las presentaciones.",
          "Nivel de preparación de reuniones.",
          "Valoración del producto presentado.",
        ],
      },
      {
        title: "Innovación",
        items: [
          "Nuevos materiales incorporados.",
          "Nuevos proveedores desarrollados.",
          "Uso efectivo de IA y herramientas digitales.",
          "Tendencias transformadas en producto comercial.",
        ],
      },
    ],
    kpis: [],
  },
  chiara,
  disenadoras,
  alex,
  guillermo: {
    id: "guillermo",
    section: "2.7",
    name: "Guillermo",
    role: "Operations & Business Coordinator",
    subtitle: null,
    reportaA: "Chief Operations & Financial Officer (COFO)",
    backupFuncional: "COFO",
    colaboraCon:
      "Founder (Irene), EC (Miguel), Head of Design (Agustina), Business Development y equipos de China.",
    accent: roleAccent("guillermo"),
    foco: [],
    noFoco: [],
    misionLabel: "Misión",
    mision:
      "Garantizar que la operación diaria de Stage Design Studio y No Man's Label fluya de forma organizada, eficiente y coordinada, conectando diseño, ventas, operaciones, logística y finanzas.\n\nAsegurar que la información correcta llegue a las personas adecuadas en el momento adecuado, anticipando incidencias, reduciendo la carga operativa de la dirección y contribuyendo a que la organización funcione con fluidez.\n\nActuar como apoyo directo del COFO y garantizar la continuidad operativa cuando sea necesario.",
    responsabilidadesLabel: "Áreas de responsabilidad",
    responsabilidades: [
      {
        title: "Coordinación Operativa",
        items: [
          "Coordinar el flujo diario entre Diseño, Business Development, Operaciones, China y Finanzas.",
          "Asegurar la correcta comunicación entre departamentos.",
          "Detectar retrasos o incidencias antes de que afecten al cliente.",
          "Coordinar prioridades y hacer seguimiento de las acciones acordadas.",
        ],
      },
      {
        title: "Timings & Desarrollo",
        groups: [
          {
            label: "Responsable del seguimiento de:",
            items: [
              "Prototipos.",
              "SMS.",
              "Producciones.",
              "Calendario general de desarrollo.",
              "Fechas de entrega.",
            ],
          },
        ],
        items: [
          "Asegurando el cumplimiento de los plazos y anticipando posibles desviaciones.",
        ],
      },
      {
        title: "Gestión de pedidos",
        items: [
          "Introducción de pedidos en Matrix / ERP.",
          "Validación de la información comercial y operativa.",
          "Seguimiento administrativo de pedidos.",
          "Coordinación con merchandising y logística.",
        ],
      },
      {
        title: "Logística",
        groups: [
          {
            label: "Responsable de:",
            items: [
              "Coordinación logística (95% FOB / 5% DDP).",
              "Seguimiento de expediciones.",
              "Preparación documental.",
              "Coordinación con transitarios.",
              "Resolución de incidencias logísticas.",
            ],
          },
        ],
      },
      {
        title: "Gestión de almacenes",
        items: [
          "Responsable de la organización y control de almacén de muestras y almacén de tejidos y materiales.",
        ],
        groups: [
          {
            label: "Garantizando:",
            items: [
              "Orden.",
              "Trazabilidad.",
              "Inventario actualizado.",
              "Optimización del espacio.",
            ],
          },
        ],
      },
      {
        title: "Venta Privada (Private Sample Sale)",
        items: [
          "Planificar y coordinar las tres ventas privadas anuales de muestras.",
        ],
        groups: [
          {
            label: "Responsable de:",
            items: [
              "Planificación del calendario.",
              "Preparación y clasificación de muestras.",
              "Organización del espacio.",
              "Coordinación del equipo.",
              "Gestión de stock durante el evento.",
              "Cierre y reporting de resultados.",
            ],
          },
        ],
      },
      {
        title: "Soporte al COFO",
        items: [
          "Dar soporte operativo al COFO en el seguimiento de operaciones.",
          "Preparar información para reporting y reuniones de seguimiento.",
          "Coordinar proyectos internos de mejora.",
          "Garantizar la continuidad operativa en ausencia del COFO.",
        ],
      },
      {
        title: "Mejora Continua",
        items: [
          "Identificar oportunidades de simplificación de procesos.",
          "Proponer mejoras operativas.",
          "Colaborar en la implantación de Matrix.",
          "Apoyar la integración de herramientas de Inteligencia Artificial en los procesos diarios.",
          "Contribuir a una organización cada vez más eficiente y escalable.",
        ],
      },
    ],
    kpiGroups: [
      {
        title: "Operación",
        items: [
          "Cumplimiento de timings de desarrollo.",
          "Nivel de cumplimiento del calendario de muestras y producción.",
          "Número de incidencias detectadas antes de llegar al cliente.",
        ],
      },
      {
        title: "Logística",
        items: [
          "% de expediciones realizadas en plazo.",
          "Número de incidencias logísticas.",
          "Exactitud de la documentación logística.",
        ],
      },
      {
        title: "Organización",
        items: [
          "Estado y organización de los almacenes.",
          "Fiabilidad del inventario de muestras y materiales.",
          "Tiempo de localización de muestras.",
        ],
      },
      {
        title: "Soporte Operativo",
        items: [
          "Calidad y puntualidad del reporting.",
          "Tiempo medio de respuesta a solicitudes internas.",
          "Nivel de satisfacción de los diferentes departamentos.",
        ],
      },
      {
        title: "Venta Privada",
        items: [
          "Organización y ejecución sin incidencias.",
          "Facturación por evento.",
          "Rotación de muestras.",
          "Satisfacción de los asistentes.",
        ],
      },
    ],
    kpis: [],
  },
  nina,
};

export const ROLE_ORDER = [
  "irene",
  "miguel",
  "borja",
  "businessDeveloper",
  "agustina",
  "chiara",
  "disenadoras",
  "alex",
  "imma",
  "guillermo",
  "nina",
];

export const mergeRolesWithDefaults = (saved = {}) => {
  const merged = {};
  ROLE_ORDER.forEach((key) => {
    const defaults = JSON.parse(JSON.stringify(DEFAULT_ROLES[key]));
    if (saved[key]) {
      merged[key] = {
        ...defaults,
        ...JSON.parse(JSON.stringify(saved[key])),
        accent: defaults.accent,
        section: defaults.section,
      };
    } else {
      merged[key] = defaults;
    }
  });
  return merged;
};
